<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="9">
            <a-form-item label="发布状态">
              <a-select
                  style="width: 250px"
                  :allowClear="true"
                  v-decorator="['status']"
                  :options="statusList"
                  :disabled="false"
                  placeholder="全部状态"
              >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="9">
            <a-form-item label="标题名称">
              <a-input
                  style="width: 250px;"
                  v-decorator="[`title`]"
                  placeholder="请输入标题名称搜索"
              />
            </a-form-item>
          </a-col>

          <a-col :span="6" :style="{ textAlign: 'right',lineHeight:'42px' }">
            <a-button type="primary" html-type="submit">
              搜索
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
              重置
            </a-button>
          </a-col>
        </a-row>

      </a-form>
    </div>

    <div class="fix ">
      <!--      左侧分类-->
      <div class="left_tree l">
        <a-spin :spinning="treeSpin" style="height: 100%">
          <div class="fix">
            <button class="btn l" @click="add" style="margin:0 3px 10px 0">新增</button>
            <button class="btn l" @click="edit" style="margin:0 3px 10px 0">编辑</button>
            <button class="btn l" @click="del" style="margin:0 3px 10px 0">删除</button>
          </div>
          <a-tree
                  :show-icon="true"
                  :checkStrictly="true"
                  :defaultExpandAll="false"
                  :defaultExpandParent="true"
                  :expandedKeys.sync="defaultExpandedKeys"
                  :tree-data="deptList"
                  :selectedKeys="selectedKeys"
                  :replaceFields="{children:'children', title:'codeName', key:'codeId', value: 'codeId' }"
                  @select="onSelect"

          >
            <!--          :checkable="true"-->
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </a-spin>
      </div>
      <!--      右边内容-->
      <a-list
          :grid="{ gutter: 35,  xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4}"
          :data-source="marketListData"
          style="width: 75%;float: left"
      >
        <a-list-item slot="renderItem" slot-scope="item">

          <div class="item_box new pr" @click="createNew" v-if="item.isFirst">
            <p class="new_icon">
              <a-icon type="plus-circle" theme="filled"/>
            </p>
            <p class="new_tips tr">创建海报</p>
          </div>

          <div class="item_box pr" v-else>
            <div class="img_box pr" @click="showDetail(item.posterId,item.layoutList)">
              <img v-if="item.posterBackgroundImg" :src="api.temp.FILE_PATH + item.posterBackgroundImg">
              <div class="pop_btns pa">
                <div class="top_btns">
                  <span class="status" :class="item.status === 1?'active':''">{{ item.statusName }}</span>
                  <p class="icons">
                  <span class="icon">
                    <a-icon type="edit" @click.stop="showDetail(item.posterId,item.layoutList)"/>
                  </span>
                    <a-popconfirm title="确定删除吗？" ok-text="确定" cancel-text="取消" @confirm="deleteItem(item.posterId)">
                      <span class="icon" @click.stop="e => e.preventDefault()"><a-icon type="delete"/></span>
                    </a-popconfirm>
                    <a-dropdown>
                      <a class="ant-dropdown-link" @click.stop="e => e.preventDefault()">
                        <span class="icon"><a-icon type="ellipsis"/></span>
                      </a>
                      <a-menu slot="overlay" @click="onClick">
                        <a-menu-item v-if="item.status === 1" @click="handleChangeStatus(item.posterId,2)">
                          取消发布
                        </a-menu-item>
                        <a-menu-item v-else @click="handleChangeStatus(item.posterId,1)">
                          发布
                        </a-menu-item>

                        <!--                      <a-menu-item key="2">统计数据</a-menu-item>-->
                        <!--                      <a-menu-item key="3">下发分享任务</a-menu-item>-->
                        <!--                      <a-menu-item key="4">复制</a-menu-item>-->
                        <!--                      <a-menu-item key="5">预览</a-menu-item>-->
                      </a-menu>
                    </a-dropdown>
                  </p>
                </div>
              </div>
            </div>
            <div class="title_box">
              <p class="title el2">{{ item.title }}</p>
            </div>
          </div>
        </a-list-item>

      </a-list>

    </div>

    <!--    分页-->
    <div v-if="totalPage>0" class="pagination" style="float: right">
      <a-pagination
          :currPage="currPage"
          :total="totalCount"
          :pageSize="limit"
          show-less-items
          @change="handleChangePage"
      />
    </div>


    <!-- 文章营销详情 -->
    <a-modal
        title="海报详情"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
        @cancel="closeEdit(false)"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          :layoutList="layoutList"
          ref="form"
          @cancelled="closeEdit(false)"
          @saved="closeEdit(true)"
      >
      </detailForm>

    </a-modal>
    <!--    新增文章分类及分组-->
    <a-modal
        title="海报分组"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editGrouping"
        @cancel="closeGrouping()"
        :width="600"
    >
      <posterKind :rowId="editGroupingId"
                   :parentId="parentId"
                   v-if="editGrouping"
                   ref="editGrouping"
                   @cancelled="closeGrouping()"
                   @saved="closeGrouping(true)">
      </posterKind>
    </a-modal>

    <!--页面加载-->
    <loading></loading>
  </div>
</template>
<script>
// 接口API
import {dataApi} from '@/services/market/spreadPoster';
// 表单
import detailForm from "./posterManageDetail";
import api from "@/services/api";
import {XEUtils} from "@/utils/common/FormBase";
import posterKind from "@/pages/web/market/posterManage/posterTreeDetail"; //新增编辑树结构
import loading from '@/components/common/loading'
export default {
  data() {
    return {
      treeSpin: false,
      defaultExpandedKeys: [],
      deptList: [],
      allList: [],
      selectedKeys: [],
      editGrouping: false, //显示新建或者编辑分类弹窗
      codeId: '',
      editGroupingId: 0,
      expand: false,
      form: this.$form.createForm(this, {name: 'advanced_search'}),
      statusList: [{
        title: '未发布',
        value: 0
      }, {
        title: '已发布',
        value: 1
      }],
      api,
      marketListData: [],
      editModalVisible: false,
      editRowId: 0,
      layoutList: null,
      search: {
        'carTypeId': ''
      },
      searchResult:{},
      totalCount: 0,//总条数
      currPage: '',//当前页
      totalPage: 0,//总页数
      page: 1,
      limit: 7,
    };
  },
  components: {
    detailForm,
    posterKind,
    loading,
  },
  mounted() {
    this.marketList();
    this.getPosterTree();
  },
  methods: {
    handleChangePage(page) {
      this.page = page;
      // 如果上方筛选有值
      if (this.searchResult['filter.inNumbers.status'] || this.searchResult['filter.like.title']) {
        this.marketList(this.searchResult);
      } else if (this.search.carTypeId) { //如果选择了左侧树结构
        this.marketList(this.search)
      } else {
        this.marketList();
      }

    },
    /**
     * 左侧树结构
     * @return {Promise<void>}
     */
    async getPosterTree() {
      let deptList = await dataApi.getPosterTree();
      this.allList = deptList.data;

      this.deptList = XEUtils.toArrayTree(deptList.data, {
        key: 'codeId',
        parentKey: 'parentId',
        children: 'children'
      })
      // this.defaultExpandedKeys = deptList.data.map(val => {
      //   //默认只展开一级
      // })
    },
    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      var that = this;
      this.form.resetFields(); //清空上方搜索内容
      this.selectedKeys = selectedKeys;
      // 清空搜索值
      this.searchResult['filter.inNumbers.status'] = ''
      this.searchResult['filter.like.title'] = ''
      this.codeId = selectedKeys[0];
      this.search.carTypeId = this.codeId
      this.page = 1
      that.marketList();
    },
    /**this
     * 新增分类
     */
    add() {
      if (this.selectedKeys.length) {
        this.parentId = this.selectedKeys[0]
      } else {
        this.parentId = null
      }
      console.log(this.selectedKeys.length, this.selectedKeys);
      this.editGroupingId = 0
      this.editGrouping = true
    },
    /**
     * 编辑分类
     */
    edit() {
      if (this.selectedKeys.length) {
        this.editGroupingId = this.selectedKeys[0]
        this.editGrouping = true
      } else {
        this.$message.error('请选择分类')
      }
    },
    /**
     * 删除分类
     */
    del() {
      const vm = this
      if (this.selectedKeys.length) {
        this.$confirm({
          title: '确定要删除分组吗',
          content: '',
          onOk() {
            vm.doDel()
          },
          onCancel() {
            console.log('Cancel');
          }
        });
      } else {
        this.$message.error('请选择海报分组')
      }
    },
    doDel() {
      dataApi.delTree(this.selectedKeys[0]).then(res => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getPosterTree()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    /**
     * 关闭弹窗
     * @param flag
     */
    closeGrouping(flag) {
      this.editGrouping = false
      if (flag) {
        this.getPosterTree()
      }
    },
    createNew() {
      this.editRowId = 0;
      this.layoutList = null;
      this.editModalVisible = true;
    },
    /**
     *  关闭详情弹窗
     */
    closeEdit() {
      this.editModalVisible = false;
      //详情新增编辑后 刷新页面
      if(status){
        this.marketList();
      }
    },
    showDetail(id, layoutList) {
      this.editRowId = id;
      this.layoutList = layoutList;
      this.editModalVisible = true;
    },
    deleteItem(id) {
      let $_that = this;

      dataApi.deleteMarketItem(id).then(entity => {
        if (entity.code === 200) {
          $_that.marketList();
          this.reload();
          // window.location.reload();
        }
      });

      // this.$confirm({
      //   title: '确认删除？',
      //   async onOk() {
      //     let entity = await dataApi.deleteMarketItem(id);
      //     if (entity.code === 200) {
      //       $_that.marketList();
      //       window.location.reload();
      //     }
      //   }
      // })
    },
    async handleChangeStatus(posterId, status) {
      var that = this;
      let result = {
        'posterId': posterId,
        'status': status,
      }
      let entity = await dataApi.changeStatus(result);
      if (entity.code === 200) {
        that.marketList();

      }
    },
    async marketList(result) {
      this.bus.$emit('loading', true);
      let entity = await dataApi.getMarketList(result ?result: this.search,this.page);
      console.log(this.search);
      if (entity.code === 200) {
        entity.data.list.forEach(item => {
          item.tagNameList = item.tagNames ? item.tagNames.split(',') : [];
        })
        entity.data.list.unshift({
          isFirst: true
        })
        this.totalCount = entity.data.totalCount //总条数
        this.currPage = entity.data.currPage ///当前页
        this.totalPage = entity.data.totalPage ///当前页
        this.marketListData = entity.data.list;
        console.log('marketListData', this.marketListData)
      }
      this.bus.$emit('loading', false);
    },
    onClick({key}) {
      console.log(`Click on item ${key}`);
    },
    async handleSearch(e) {
      e.preventDefault();
      // 清空选中树结构分类
      this.selectedKeys = []
      this.search.carTypeId = ''
      // let searchResult;
      this.form.validateFields((error, values) => {
         this.searchResult = {
          'filter.inNumbers.status': values.status,
          'filter.like.title': values.title,
        }
        this.marketList(this.searchResult)
      });
    },

    handleReset() {
      // 清空选中树结构分类
      this.selectedKeys = []
      this.search.carTypeId = ''
      this.form.resetFields();
      this.searchResult['filter.like.title'] = ""
      this.searchResult['filter.inNumbers.status'] = ""
      this.marketList();
    },


    // toggle() {
    //   this.expand = !this.expand;
    // },
  }
};
</script>
<style scoped lang="less">
@import "../../../../assets/css/marketList.less";

.ant-pagination{
padding-bottom: 20px;
}

//左边树结构
.left_tree {
  width: 20%;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: auto;
  margin-right: 20px;

  .btn {
    font-size: 12px;
    height: 28px;
    padding: 0 1em;
    border: 1px solid #dcdfe6;
    color: #606266;
    cursor: pointer;
    border-radius: 4px;
    background-color: #fff;
  }
  .btn:hover{
    color: #D90B18;
  }
}

.ant-advanced-search-form {
  padding: 24px 24px 12px;
  background: #fbfbfb;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-bottom: 12px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}


</style>
